import axios from 'axios';

// VMS BE proxy → MCP 서버
// FE 가 직접 MCP 서버를 호출하면 CORS 문제 + 내부 endpoint 노출 위험이 있어
// BE 의 /api/private/id-masking/check 를 거쳐 forward 된다.
const ID_MASKING_API = '/api/private/id-masking/check';

/**
 * LLM 으로 신분증/면허증 이미지의 개인정보 마스킹 여부를 검사한다.
 * documentType 은 MCP 서버가 자동 판별하여 응답에 포함한다.
 *
 * @param {File} file - 이미지 파일
 * @returns {Promise<{
 *   documentType: string,
 *   documentSubtype: string,
 *   fullyMasked: boolean,
 *   exposedFields: string[],
 *   maskedFields: string[],
 *   overallAssessment: string,
 *   confidence: number,
 *   rawResponse: string
 * }>}
 */
export async function checkIdMasking(file) {
  const formData = new FormData();
  formData.append('image', file);

  const response = await axios.post(ID_MASKING_API, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 65000  // BE timeout(60s) 보다 약간 길게
  });
  return response.data;
}